module.exports = __webpack_public_path__ + "img/betflix-support.5347c450.png";